/** Keys for OAuth (Hosted UI) session when using federated sign-in (e.g. Google). */
const OAUTH_TOKEN_KEY = 'darlink_oauth_id_token';
const OAUTH_REFRESH_KEY = 'darlink_oauth_refresh_token';

export function getStoredOAuthIdToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(OAUTH_TOKEN_KEY);
}

export function clearStoredOAuthSession(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(OAUTH_TOKEN_KEY);
  localStorage.removeItem(OAUTH_REFRESH_KEY);
}

export function setStoredOAuthTokens(idToken: string, refreshToken?: string): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(OAUTH_TOKEN_KEY, idToken);
  if (refreshToken) localStorage.setItem(OAUTH_REFRESH_KEY, refreshToken);
}
